import * as React from 'react';

import { useVisibilityTracker } from '@coursera/event-pulse/react';

import type { PromoTemplatePartnerListFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import Section from 'bundles/front-page/components/Section';
import { type PartnerLogoData } from 'bundles/unified-common/components/partner-logos/PartnerLogo';
import PartnerLogosComponent from 'bundles/unified-common/components/partner-logos/PartnerLogosComponent';
import getPartnerData from 'bundles/unified-common/components/partner-logos/getPartnerData';

import _t from 'i18n!nls/front-page';

type Props = {
  content?: PromoTemplatePartnerListFragment;
};

/**
 * Displays interactive partner logos / names within an overflow carousel.
 */
const PartnerLogosModuleRenderer = ({ content }: Props) => {
  const partnerItems =
    content?.partnersCollection?.items?.filter(
      (item): item is NonNullable<typeof item> & PartnerLogoData =>
        !!item && !!item.name && !!item.logo?.url && !!item.target
    ) ?? [];

  const partnerData =
    partnerItems.length > 0
      ? partnerItems.map((item) => ({
          name: item.name,
          logo: item.logo.url!,
          href: item.target!,
        }))
      : getPartnerData();

  const visibilityTrackerRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_page_section',
    {
      pageSection: {
        sectionName: 'partner_logo_list',
      },
    }
  );

  return (
    <Section title={_t('Learn from 350+ leading universities and companies')} dataTestId="partner-logos">
      <div ref={visibilityTrackerRef}>
        <PartnerLogosComponent partners={partnerData} />
      </div>
    </Section>
  );
};

export default PartnerLogosModuleRenderer;
